const PromoCouponGreen = ({ width = 11, height = 11, className='' }) => (
    <svg
      width={width}
      height={height}
      viewBox="0 0 11 11"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g id="Group">
        <path
          id="Vector"
          d="M0.20625 6.20625L5.70625 0.70625C5.84375 0.56875 5.98125 0.5 6.1875 0.5H10.3125C10.725 0.5 11 0.775 11 1.1875V5.3125C11 5.51875 10.9312 5.65625 10.7937 5.79375L5.29375 11.2937C5.15625 11.4312 5.01875 11.5 4.8125 11.5C4.60625 11.5 4.46875 11.4312 4.33125 11.2937L0.20625 7.16875C-0.0687494 6.89375 -0.0687494 6.48125 0.20625 6.20625ZM8.25 3.9375C8.6625 3.9375 8.9375 3.6625 8.9375 3.25C8.9375 2.8375 8.6625 2.5625 8.25 2.5625C7.8375 2.5625 7.5625 2.8375 7.5625 3.25C7.5625 3.6625 7.8375 3.9375 8.25 3.9375Z"
          fill="#078184"
        />
      </g>
    </svg>
  );
   
  export default PromoCouponGreen;
